import {
    never,
    of,
} from 'rxjs';

import isEmpty from '../../../Shared/Utils/isEmpty';
import ErrorType from '../../../Errors/Constants/Error.type';

const interceptPlaybackServiceResponse = handleError => serviceResponse => {
    if (isEmpty(serviceResponse) || typeof serviceResponse !== 'object') {
        handleError({
            type: ErrorType.API_SERVICE_PLAYBACK_MISSING_DATA,
            source: new Error(ErrorType.API_SERVICE_PLAYBACK_MISSING_DATA),
        });
        return never();
    }

    const response = Object
        .keys(serviceResponse)
        .reduce((output, currentService) => {
            const service = serviceResponse[currentService];

            if (isEmpty(service)) {
                const type = `API_SERVICE_PLAYBACK_${currentService.toUpperCase()}_UNAVAILABLE`;
                const source = new Error(type);
                handleError({
                    type,
                    source,
                });
                output[currentService] = null;
            } else {
                output[currentService] = service;
            }

            return output;
        }, {});

    return of(response);
};

export default interceptPlaybackServiceResponse;
